export const defaultState = () => ({
	analytics : {
		impressions : 0,
		conversions : 0,
		rate        : 0.0,
	},
	topCampaigns : [],
	dateRange    : {
		preset : true,
		filter : '30-days',
		start  : '',
		end    : '',
	},
	dismissedWelcomeBack : false,
	minDate              : '2019-04-10',
})
export default defaultState()
